const toCamelCase = str => {
    const camelCased = str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase()
    })
    return camelCased
}

const objectIsEmpty = obj => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
    }
    return true
}

const splitDateTimeString = dtt => {
    dtt = dtt.split(' ')
    let date = dtt[0]
    let time = dtt[1].split('.')
    time = time[0]
    return { date, time }
}

const padStartInteger = (int, length, str = '0') =>
    ('' + int).padStart(length, str)

const dateToYYYYMMDD = date =>
    `${date.getFullYear()}-${padStartInteger(
        date.getMonth() + 1,
        2,
        0
    )}-${padStartInteger(date.getDate(), 2, 0)}`

const dateToHHmmSS = date =>
    `${padStartInteger(date.getHours(), 2, 0)}:${padStartInteger(
        date.getMinutes(),
        2,
        0
    )}:${padStartInteger(date.getSeconds(), 2, 0)}`

const dateToYYYYMMDDHHmmSS = date =>
    dateToYYYYMMDD(date) + ' ' + dateToHHmmSS(date)

const addMonthsToDate = (date, months) => {
    const d = new Date(date)
    d.setMonth(d.getMonth() + months)
    return d
}

const numberFormatter = n => {
    if (isNaN(n)) n = parseFloat(n)
    let arr = n.toString().split('.')
    let prefix = ''
    if (arr[0].charAt(0) === '-') {
        prefix = '-'
        arr[0] = arr[0].substr(1)
    }
    let int = arr[0]
        .split('')
        .reverse()
        .join('')
    let aux = []
    for (let i = 0; i < int.length; i += 3) {
        aux.push(int.substr(i, 3))
    }
    arr[0] = aux
        .join('.')
        .split('')
        .reverse()
        .join('')
    return prefix + arr.join(',')
}

export {
    toCamelCase,
    objectIsEmpty,
    splitDateTimeString,
    padStartInteger,
    dateToYYYYMMDD,
    dateToHHmmSS,
    dateToYYYYMMDDHHmmSS,
    addMonthsToDate,
    numberFormatter,
}
